module.exports = __webpack_public_path__ + "static/media/cq_modifica_dati_b.705f89d0.svg";